/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { Button } from '@mairistem/composants';

import { GestionTrimestreActions } from '@/enums';
import ModalGestionTrimestreRow from './ModalGestionTrimestreRow';

// @ts-expect-error
import iconNumerotation from '../../../../assets/images/numerotation.png';

interface ModalGestionTrimestreRowNumerotationProps {
  numerotation: Date;
  loading: boolean;
  onNumerotation: (action: GestionTrimestreActions) => void;
  isClotured?: boolean;
}

const ModalGestionTrimestreRowNumerotation = (
  props: ModalGestionTrimestreRowNumerotationProps,
) => {
  const { numerotation, loading, onNumerotation, isClotured = false } = props;

  const [numerotationLoading, setNumerotationLoading] =
    React.useState<boolean>(false);
  const [denumerotationLoading, setDenumerotationLoading] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    if (!loading) {
      setNumerotationLoading(false);
      setDenumerotationLoading(false);
    }
  }, [loading]);

  const handleNumerotation = React.useCallback(
    (action: GestionTrimestreActions) => {
      if (action === GestionTrimestreActions.DENUMEROTATION) {
        setDenumerotationLoading(true);
      } else {
        setNumerotationLoading(true);
      }
      onNumerotation(action);
    },
    [onNumerotation],
  );

  const content = React.useMemo(
    () => (
      <>
        <h3>Numérotation des recensés</h3>
        {numerotation ? (
          <p>
            <i>
              Trimestre numéroté le
              {` ${numerotation.toLocaleDateString()}`}
            </i>
          </p>
        ) : (
          <p>
            <i>Numérotation du trimestre non effectuée</i>
          </p>
        )}
      </>
    ),
    [numerotation],
  );

  const actions = React.useMemo(
    () => (
      <>
        <Button
          data-testid="modal-gestion-trimestre-bouton-numerotation"
          content={!_.isNil(numerotation) ? 'Renuméroter' : 'Numéroter'}
          color={!_.isNil(numerotation) ? 'green' : 'blue'}
          onClick={() =>
            handleNumerotation(
              !_.isNil(numerotation)
                ? GestionTrimestreActions.RENUMEROTATION
                : GestionTrimestreActions.NUMEROTATION,
            )
          }
          loading={numerotationLoading}
          style={{ width: 130 }}
          disabled={loading || isClotured}
        />
        <Button
          data-testid="modal-gestion-trimestre-bouton-denumerotation"
          content="Dénuméroter"
          color="blue"
          onClick={() =>
            handleNumerotation(GestionTrimestreActions.DENUMEROTATION)
          }
          loading={denumerotationLoading}
          style={{ width: 130 }}
          disabled={_.isNil(numerotation) || loading || isClotured}
        />
      </>
    ),
    [
      loading,
      numerotation,
      numerotationLoading,
      denumerotationLoading,
      handleNumerotation,
      isClotured,
    ],
  );

  return (
    <ModalGestionTrimestreRow
      icon={iconNumerotation}
      content={content}
      actions={actions}
    />
  );
};

export default ModalGestionTrimestreRowNumerotation;
